module.exports = __webpack_public_path__ + "static/media/鹤老汇2.50ff86eb.png";